module.exports = __webpack_public_path__ + "static/img/CAMDEN_MAPLE.b540f9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/CAMDEN_MAPLE.jpg
// module id = VvtX
// module chunks = 0